import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/domains/common/components/tabs"

export type TokenDialogTab = {
  id: string
  label: string
  content: React.ReactNode
}

export const TokenDialogTabs: React.FC<{
  tabs: Array<TokenDialogTab>
  defaultValue?: string
  value?: string
  onValueChange?: (value: string) => void
}> = ({ tabs, defaultValue, value, onValueChange }) => {
  return (
    <Tabs defaultValue={defaultValue} value={value} onValueChange={onValueChange} className="flex flex-grow flex-col">
      <div>
        <TabsList className="mb-4 mr-1 grid grid-cols-3" defaultValue={defaultValue}>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
      {tabs.map((tab) => (
        <TabsContent key={tab.id} value={tab.id} asChild>
          <div className="tab-content flex h-full flex-grow flex-col gap-3">{tab.content}</div>
        </TabsContent>
      ))}
    </Tabs>
  )
}
